import { showError } from 'helpers/handleError';
import { notifySuccess } from 'helpers/handleNotification';
import { takeLatest, put } from 'redux-saga/effects';
import types from 'redux/types';
import PremiumOrderServices from 'services/PremiumOrderServices';

function* createOrder(data) {
  const { duration, volume, callbacks, messageType } = data;
  try {
    const res = yield PremiumOrderServices.createOrder({ duration, volume, messageType });
    callbacks && callbacks.onSuccess(res);
    notifySuccess('Ordered successfully!');
  } catch (error) {
    showError(error.toString(), 'Error');
    yield put({ type: types.REQUEST_GET_GUIDE_FAILED, error });
  }
}

function* getListOrder(data) {
  const { callbacks, filters = {} } = data;
  try {
    const res = yield PremiumOrderServices.listOrder(filters);
    callbacks && callbacks.onSuccess(res);
  } catch (error) {
    callbacks && callbacks.onFailed(error);
  }
}

function* checkCredit(data) {
  const { duration, volume, callbacks } = data;
  try {
    const res = yield PremiumOrderServices.checkCredit({ duration, volume });
    callbacks && callbacks.onSuccess(res);
  } catch (error) {
    callbacks && callbacks.onFailed(error);
  }
}

export default function* () {
  yield takeLatest(types.REQUEST_CREATE_ORDER, createOrder);
  yield takeLatest(types.REQUEST_GET_LIST_ORDER, getListOrder);
  yield takeLatest(types.REQUEST_CHECK_CREDIT, checkCredit);
}
